import React, { useMemo } from "react";
import "./CommonPage.css";
import "./EmailComponents.css";

import Navbar from "../Common/Navbar";
import EmailIdeasSection from "./EmailPackage/EmailIdeasSection";
import BusinessEmailSection from "./EmailPackage/BusinessEmailSection";
import EmailPlansSection from "./EmailPackage/EmailPlansSection";
import InboxSecuritySection from "./EmailPackage/InboxSecuritySection";
import SharedMailboxesSection from "./EmailPackage/SharedMailboxesSection";
import WebmailAccessSection from "./EmailPackage/WebmailAccessSection";
import BackupRecoverySection from "./EmailPackage/BackupRecoverySection";

function Email() {
  const emailFeatureCards = useMemo(
    () => [
      {
        key: "business_email",
        title: "Business Email",
        description: "Create custom domain-based email accounts for your team.",
        icon: "📧",
      },
      {
        key: "email_plans",
        title: "Email Plans",
        description: "Choose the right email hosting plan for your business needs.",
        icon: "💼",
      },
      {
        key: "inbox_security",
        title: "Inbox Security",
        description: "Protect your communications with secure email features.",
        icon: "🛡️",
      },
      {
        key: "shared_mailboxes",
        title: "Shared Mailboxes",
        description:
          "Collaborate with your team using shared support and sales inboxes.",
        icon: "👥",
      },
      {
        key: "webmail_access",
        title: "Webmail Access",
        description: "Use your email from anywhere with simple web-based access.",
        icon: "🌐",
      },
      {
        key: "backup_recovery",
        title: "Backup & Recovery",
        description:
          "Keep business communication safe with backup and restore options.",
        icon: "♻️",
      },
    ],
    []
  );

  const handleCardClick = (key) => {
    const section = document.getElementById(`email-section-${key}`);

    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <>
      <Navbar />

      <section className="common-page-section email-page-new">
        <div className="common-page-container email-page-container">
          <div className="email-hero-layout">
            <div className="email-hero-left">
              <span className="common-page-badge">Email Services</span>

              <h1>Professional Email Services</h1>

              <p>
                Create branded email accounts for your business and manage inbox
                services with a modern, secure, and business-ready experience.
              </p>

              <div className="email-hero-actions">
                <button
                  type="button"
                  onClick={() => handleCardClick("business_email")}
                >
                  Get Business Email
                </button>

                <button
                  type="button"
                  onClick={() => handleCardClick("email_plans")}
                >
                  View Plans
                </button>
              </div>

              <div className="email-trust-row">
                <span>📨 Custom domain email</span>
                <span>🔒 Secure inbox</span>
                <span>⚡ Fast setup</span>
              </div>
            </div>

            <div className="email-hero-right">
              <div className="email-preview-card">
                <div className="email-preview-top">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>

                <div className="email-preview-content">
                  <div className="email-avatar">AE</div>
                  <div>
                    <h3>hello@yourdomain.com</h3>
                    <p>Business-ready professional email account</p>
                  </div>
                </div>

                <div className="email-preview-list">
                  <div>
                    <strong>Inbox Security</strong>
                    <span>Active</span>
                  </div>
                  <div>
                    <strong>Backup Recovery</strong>
                    <span>Enabled</span>
                  </div>
                  <div>
                    <strong>Shared Mailbox</strong>
                    <span>Team Ready</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <EmailIdeasSection />

          <div className="common-page-card-grid email-feature-grid">
            {emailFeatureCards.map((item) => (
              <button
                type="button"
                className="common-page-card email-feature-card"
                key={item.key}
                onClick={() => handleCardClick(item.key)}
              >
                <div className="email-feature-icon">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
                <span>Explore →</span>
              </button>
            ))}
          </div>

          <div className="email-sections-grid">
            <div id="email-section-business_email">
              <BusinessEmailSection />
            </div>

            <div id="email-section-email_plans">
              <EmailPlansSection />
            </div>

            <div id="email-section-inbox_security">
              <InboxSecuritySection />
            </div>

            <div id="email-section-shared_mailboxes">
              <SharedMailboxesSection />
            </div>

            <div id="email-section-webmail_access">
              <WebmailAccessSection />
            </div>

            <div id="email-section-backup_recovery">
              <BackupRecoverySection />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Email;